export const FLAG_IMG_BY_COUNTRY: string[] = [
    // eslint-disable-next-line max-len
    'au', 'bg', 'br', 'ca', 'ch', 'cn', 'cz', 'de', 'es', 'fr', 'gb', 'hu', 'il', 'in', 'it', 'jp', 'kr', 'nl', 'pl', 'ro', 'se', 'sg', 'tr', 'us',
];
